import sObjetos from '@/aplicacao/_servicos/objetos'

function State() {
    this.aberto = false
    this.resolver = null
}

const mutations = {

    resetar(stateParam) {
        sObjetos.preencher(stateParam, new State())
    },

    setAberto(state, payload) {
        state.aberto = payload
    },

    setResolver(state, payload) {
        state.resolver = payload
    },

}

const actions = {

    resetar({ commit }, payload) {
        commit('resetar', payload)
    },

    solicitarFoto({ commit }) {
        commit('setAberto', true)
        return new Promise((resolve, reject) => {
            commit('setResolver', resolve)
        })
    },

    enviarFotoCapturada({ state, commit }, payload) {
        state.resolver({ tirou: true, foto: payload })
        commit('setAberto', false)
        commit('setResolver', null)
    },

    fecharSemCapturarFoto({ state, commit }) {
        state.resolver({ tirou: false })
        commit('setAberto', false)
        commit('setResolver', null)
    },

}

const getters = {

}

export default {
    state: new State(),
    mutations,
    actions,
    getters,
}
